'use client';

import { useState } from 'react';
import Image from 'next/image';
import styles from './HeaderMenu.module.scss';
import { IconMenu } from '@/public/assets/icons/IconMenu';
import LogoBlue from '@/public/assets/icons/LogoBlue/LogoBlue.svg';
import LogoEng from '@/public/assets/icons/LogoEng/LogoEng.svg';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';
import { FeedbackForm } from '../FeedbackForm';
import { trackEvent } from '@/shared/components/GoogleMetrika/GoogleMetrika';

export function HeaderMenu() {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);
  const t = useTranslations('headerMenu');
  const locale = useLocale();
  const logo = locale === 'en' ? LogoEng : LogoBlue;

  const buttonsMenu = [
    { href: '#description', text: t('description') },
    { href: '#process', text: t('process') },
    { href: '#screens', text: t('screens') },
    { href: '#qa', text: t('qa') },
    { href: '#partners', text: t('partners') },
    { href: locale === 'en' ? 'https://i-sol.eu/' : 'https://i-sol.ru/', text: t('company'), target: '_blank' },
  ];

  const handleOpenMenu = () => {
    setIsOpenMenu(true);
  };

  const handleCloseMenu = () => {
    setIsOpenMenu(false);
  };

  const handleOpenFeedback = () => {
    trackEvent('button_click', {
      button_name: 'contact_from_button',
      page: window.location.pathname,
    });
    setFeedbackOpen(true);
    handleCloseMenu();
  };

  const handleCloseFeedback = () => {
    setFeedbackOpen(false);
  };

  return (
    <>
      <div className={styles.headerMobile}>
        <figure>
          <Image
            className={styles.logo}
            src={logo}
            alt="logo plan gr mine"
            width={108}
            height={69}
          />
        </figure>
        <div className={styles.iconMenu}>
          <IconMenu
            isOpen={isOpenMenu}
            onClick={() => setIsOpenMenu(!isOpenMenu)}
          />
        </div>
      </div>
      <nav className={`${styles.nav} ${isOpenMenu ? styles.activeNav : ''}`}>
        <ul>
          {buttonsMenu.map((b) => (
            <li key={b.href} onClick={handleCloseMenu}>
              <a href={b.href} target={b.target}>
                {b.text}
              </a>
            </li>
          ))}
        </ul>
        <div className={styles.headerButtonsWrapper}>
          <button
            className={`${styles.button} ${styles.headerButton}`}
            onClick={handleOpenFeedback}
          >
            {t('connect')}
          </button>
          {/* <Link href={`/${locale}/demo`} legacyBehavior>
            <button className={`${styles.button} ${styles.headerButton}`}>
              {t('demo')}
            </button>
          </Link> */}
        </div>
      </nav>
      <FeedbackForm isOpen={isFeedbackOpen} onClose={handleCloseFeedback} />
    </>
  );
}
